import { render, staticRenderFns } from "./VerifyMicroDeposits.vue?vue&type=template&id=b48abdde"
import script from "./VerifyMicroDeposits.vue?vue&type=script&lang=js"
export * from "./VerifyMicroDeposits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports